import { Card, Group, Skeleton, Stack, Text, ThemeIcon } from '@mantine/core';
import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

interface Props {
  label: string;
  value: ReactNode;
  sub?: ReactNode;
  icon?: ReactNode;
  color?: string;
  loading?: boolean;
  to?: string;
}

export function MetricTile({ label, value, sub, icon, color = 'indigo', loading, to }: Props) {
  const inner = (
    <Card
      withBorder
      padding="md"
      radius="md"
      style={{ height: '100%', cursor: to ? 'pointer' : 'default' }}
    >
      <Group justify="space-between" align="flex-start">
        <Stack gap={4} style={{ flex: 1 }}>
          <Text c="dimmed" size="xs" tt="uppercase" fw={600}>
            {label}
          </Text>
          {loading ? (
            <Skeleton height={28} width={80} />
          ) : (
            <Text fw={700} size="xl">
              {value}
            </Text>
          )}
          {sub && !loading && (
            <Text c="dimmed" size="xs">
              {sub}
            </Text>
          )}
        </Stack>
        {icon && (
          <ThemeIcon color={color} variant="light" size="lg" radius="md">
            {icon}
          </ThemeIcon>
        )}
      </Group>
    </Card>
  );
  if (to) {
    return (
      <Link to={to} style={{ textDecoration: 'none', color: 'inherit' }}>
        {inner}
      </Link>
    );
  }
  return inner;
}
